module.exports = __webpack_public_path__ + "img/mobile-2.28ace56a.png";